import React from 'react';
import styled from 'styled-components';

const StyledModalMainContentContainer = styled.div`
  padding: 16px 24px;
  max-width: 900px;
  overflow-x: auto;
  max-height: 80vh;
  overflow-y: auto;
`;

export default function ModalMainContentContainer({children}: {children: React.ReactNode}) {
  return <StyledModalMainContentContainer>{children}</StyledModalMainContentContainer>;
}
